import { useAuthQuery } from './useAuthQuery';
import { useMutationWithToast } from './useQueryWithToast';
import { supabase } from '@/integrations/supabase/client';

// Hook to add stakeholder from global list to project
export const useAddGlobalStakeholderToProject = () => {
  return useMutationWithToast<any, {
    projectId: string;
    stakeholderId: string;
    role: string;
  }>({
    mutationFn: async ({ projectId, stakeholderId, role }) => {
      const { data, error } = await supabase
        .from('project_stakeholder_assignments')
        .insert({
          project_id: projectId,
          stakeholder_id: stakeholderId,
          role,
          assigned_by: null
        })
        .select()
        .single();

      if (error) throw error;
      return data;
    },
    successMessage: 'Đã thêm stakeholder vào dự án thành công',
    invalidateQueries: [['project-stakeholders']]
  });
};

// Hook to create new stakeholder and assign to project
export const useCreateAndAssignStakeholder = () => {
  return useMutationWithToast<any, {
    projectId: string;
    name: string;
    email?: string;
    phone?: string;
    role: string;
    company?: string;
    description?: string;
  }>({
    mutationFn: async ({ projectId, name, email, phone, role, company, description }) => {
      // First create the stakeholder
      const { data: stakeholder, error: stakeholderError } = await supabase
        .from('stakeholders')
        .insert({
          name,
          email: email || null,
          phone: phone || null,
          role,
          company: company || null,
          description: description || null
        })
        .select()
        .single();

      if (stakeholderError) throw stakeholderError;

      // Then assign to project
      const { data: assignment, error: assignmentError } = await supabase
        .from('project_stakeholder_assignments')
        .insert({
          project_id: projectId,
          stakeholder_id: stakeholder.id,
          role,
          assigned_by: null
        })
        .select()
        .single();

      if (assignmentError) throw assignmentError;
      return assignment;
    },
    successMessage: 'Đã tạo và thêm stakeholder thành công',
    invalidateQueries: [['project-stakeholders'], ['stakeholders']]
  });
};